import { HttpClient, HttpParams } from '@angular/common/http';

import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';



export interface CustomerPortalUserSummary {

    id: number;

    customerId: string;

    customerName: string;

    email: string;

    company: string;

    division: string;

    warehouse: string;

    phoneNo: string;

    verify: string;

    portalEnabled: boolean;

}



export interface CustomerPortalUserPage {

    content: CustomerPortalUserSummary[];

    page: number;

    size: number;

    totalElements: number;

    totalPages: number;

}



export interface CreateCustomerPortalUserRequest {

    customerId: string;

    customerName: string;

    email: string;

    password: string;

    company: string;

    division: string;

    warehouse: string;

    phoneNo?: string;

    mustChangePassword?: boolean;

}



export interface CustomerPortalImportRowPreview {

    rowNum: number;

    customerId: string;

    email: string;

    previewOutcome: string;

    message: string;

}



export interface CustomerPortalImportPreview {

    totalRows: number;

    okCount: number;

    skipCount: number;

    errorCount: number;

    truncated: boolean;

    rows: CustomerPortalImportRowPreview[];

}



export interface CustomerPortalImportJob {

    id: number;

    staffEmail: string;

    status: string;

    dryRun: boolean;

    totalRows: number;

    processedRows: number;

    createdCount: number;

    skippedCount: number;

    errorCount: number;

    startedAt?: string;

    finishedAt?: string;

    failureMessage?: string;

}



@Injectable({ providedIn: 'root' })

export class CustomerPortalUserService {

    private readonly baseUrl = `${environment.authApiUrl}staff/customer-users`;



    constructor(private http: HttpClient) {}



    list(params: {

        customerId?: string;

        email?: string;

        company?: string;

        division?: string;

        page?: number;

        size?: number;

    }): Observable<CustomerPortalUserPage> {

        let httpParams = new HttpParams();

        if (params.customerId) httpParams = httpParams.set('customerId', params.customerId);

        if (params.email) httpParams = httpParams.set('email', params.email);

        if (params.company) httpParams = httpParams.set('company', params.company);

        if (params.division) httpParams = httpParams.set('division', params.division);

        httpParams = httpParams.set('page', String(params.page ?? 0));

        httpParams = httpParams.set('size', String(params.size ?? 20));

        return this.http.get<CustomerPortalUserPage>(this.baseUrl, { params: httpParams });

    }



    lookup(customerId: string): Observable<CustomerPortalUserSummary> {

        const params = new HttpParams().set('customerId', customerId);

        return this.http.get<CustomerPortalUserSummary>(`${this.baseUrl}/lookup`, { params });

    }



    create(request: CreateCustomerPortalUserRequest): Observable<string> {

        return this.http.post(this.baseUrl, request, { responseType: 'text' });

    }



    update(id: number, body: { portalEnabled?: boolean; mustChangePassword?: boolean }): Observable<CustomerPortalUserSummary> {

        return this.http.patch<CustomerPortalUserSummary>(`${this.baseUrl}/${id}`, body);

    }



    resetPassword(id: number): Observable<string> {

        return this.http.post(`${this.baseUrl}/${id}/reset-password`, {}, { responseType: 'text' });

    }



    downloadImportTemplate(): Observable<Blob> {

        return this.http.get(`${this.baseUrl}/import/template`, { responseType: 'blob' });

    }



    previewImport(file: File): Observable<CustomerPortalImportPreview> {

        const form = new FormData();

        form.append('file', file);

        return this.http.post<CustomerPortalImportPreview>(`${this.baseUrl}/import/preview`, form);

    }



    startImportJob(file: File, dryRun: boolean): Observable<CustomerPortalImportJob> {

        const form = new FormData();

        form.append('file', file);

        const params = new HttpParams().set('dryRun', String(dryRun));

        return this.http.post<CustomerPortalImportJob>(`${this.baseUrl}/import/jobs`, form, { params });

    }



    getImportJob(jobId: number): Observable<CustomerPortalImportJob> {

        return this.http.get<CustomerPortalImportJob>(`${this.baseUrl}/import/jobs/${jobId}`);

    }



    downloadImportErrors(jobId: number): Observable<Blob> {

        return this.http.get(`${this.baseUrl}/import/jobs/${jobId}/errors.csv`, { responseType: 'blob' });

    }

}


